module.exports = __webpack_public_path__ + "img/hansen.b78ae436.jpg";